import { createSelector } from '@reduxjs/toolkit';

import { CeilingTrayGeometry } from '@paragon/layout';
import { notNullish } from '@paragon/utilities';

import { isInsertionCeilingTrayFullyDefined } from '../slices/applicationSlice';
import { getInsertingObjectInfo } from './insertionObjectSelectors';
import { getVisibleCeilingTrays } from './layoutDataSelectors';

export const getInsertionCeilingTray = createSelector(getInsertingObjectInfo, (insertingObjectInfo) => {
  if (insertingObjectInfo?.type === 'ceilingTray') {
    return insertingObjectInfo.data;
  }
});

export const getCalculatedInsertionCeilingTray = createSelector(getInsertionCeilingTray, (insertionTray) => {
  if (insertionTray && isInsertionCeilingTrayFullyDefined(insertionTray)) {
    return CeilingTrayGeometry.fromTray(insertionTray);
  }
});

export const getCalculatedCeilingTrays = createSelector(getVisibleCeilingTrays, (ceilingTrays) =>
  ceilingTrays.map(CeilingTrayGeometry.fromTray).filter(notNullish),
);
